module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-photo-gift-709e6148adf5bfbd560808279eb1d901.jpg";